<template>
    <div class="date-selector">
        <v-menu>
            <template v-slot:activator="{ props }">
                <v-text-field clearable
                              class="ma-0 pa-0"
                              variant="outlined"
                              density="compact"
                              v-bind="props"
                              :model-value="dateString"
                              @update:modelValue="dateString = $event"
                              :label="label"
                              type="text" />
            </template>

            <v-list>
                <v-list-item>
                    <v-date-picker v-model="dateTime"
                                   show-adjacent-months
                                   hide-header
                                   class="text-primary"
                                   color="primary" />
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    import { DateTime } from "luxon";

    export default {
        components: {

        },

        props: {
            modelValue: Object,
            label: String
        },

        emits: ["update:modelValue"],

        data() {
            return {
                dateTime: this.modelValue,
                dateString: this.getDateString(this.modelValue)
            };
        },

        computed: {
            currentLocale() {
                return this.$store.state.currentLocale;
            }
        },

        watch: {
            modelValue(newValue) {
                this.dateTime = newValue;
                this.dateString = this.getDateString(newValue);
            },

            dateTime(newValue) {
                this.update(newValue);
            },

            dateString(newValue) {
                const dateTime = this.getDateTime(newValue);

                this.update(dateTime);
            }
        },

        methods: {
            getDateTime(dateString) {
                if (!dateString) {
                    return null;
                }

                let dateTime = DateTime.fromISO(dateString);

                if (!dateTime.isValid) {
                    dateTime = DateTime.fromFormat(dateString, "yyyy.MM.dd");
                }
                if (!dateTime.isValid) {
                    dateTime = DateTime.fromFormat(dateString, "dd.MM.yyyy");
                }

                if (!dateTime.isValid) {
                    return null;
                }

                return dateTime;
            },

            getDateString(dateTime) {
                if (!dateTime) {
                    return "";
                }

                return dateTime.setLocale(this.currentLocale).toFormat("yyyy.MM.dd");
            },

            update(dateTime) {
                this.$emit("update:modelValue", dateTime);
            }
        }
    };
</script>

<style lang="scss">
    .date-selector {
        width: 150px;
    }

    .date-selector .v-input__details {
        display: none;
    }
</style>